class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    if(window.innerWidth > 749){
      const detailsElement = this.drawer.querySelector('details');
      if (detailsElement.hasAttribute('open')) {
        return;
      }
      
      this.drawer.openMenuDrawer();

      setTimeout(() => {
        setHeaderHeight();
      }, 250);
    }
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

      if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);

function isiPhone() {
  return /iPhone/.test(navigator.userAgent) && !window.MSStream;
}

if (isiPhone()) {
  const cartDrawer = document.querySelector('cart-drawer'); // Update this selector!

  function resizeCartDrawer() {
    if (!cartDrawer) return;

    const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    cartDrawer.style.height = vh + 'px';
  }

  // Resize when drawer opens (observe or hook into open event)
  const observer = new MutationObserver(() => {
    const isVisible = cartDrawer && window.getComputedStyle(cartDrawer).display !== 'none';
    if (isVisible) {
      resizeCartDrawer();
    }
  });

  if (cartDrawer) {
    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  // Also resize on scroll and resize (when browser UI shows)
  //window.addEventListener('resize', resizeCartDrawer);
 // window.addEventListener('scroll', resizeCartDrawer);
}

